import { render, staticRenderFns } from "./chosePeriodVesselBalances.vue?vue&type=template&id=6dd2a707"
import script from "./chosePeriodVesselBalances.vue?vue&type=script&lang=js"
export * from "./chosePeriodVesselBalances.vue?vue&type=script&lang=js"
import style0 from "./chosePeriodVesselBalances.vue?vue&type=style&index=0&id=6dd2a707&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports